/** Wall-clock display for Sidekick. Always Europe/Sofia (EET/EEST). */

export const APP_TIME_ZONE = 'Europe/Sofia';
const APP_LOCALE = 'en-GB';

function asDate(value: string | number | Date): Date | null {
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }
  if (typeof value === 'number') {
    const d = new Date(value);
    return Number.isNaN(d.getTime()) ? null : d;
  }
  const raw = value.trim();
  if (!raw) return null;
  // Datetime without an offset is stored as UTC (Node toISOString / naive UTC clocks).
  let s = raw;
  if (
    /^\d{4}-\d{2}-\d{2}T/.test(s) &&
    !/[zZ]$/.test(s) &&
    !/[+-]\d{2}:?\d{2}$/.test(s)
  ) {
    s = `${s}Z`;
  }
  const d = new Date(s);
  return Number.isNaN(d.getTime()) ? null : d;
}

export function formatAppTime(
  value: string | number | Date,
  withSeconds = true,
): string {
  const d = asDate(value);
  if (!d) return '';
  return d.toLocaleTimeString(APP_LOCALE, {
    timeZone: APP_TIME_ZONE,
    hour: '2-digit',
    minute: '2-digit',
    ...(withSeconds ? { second: '2-digit' as const } : {}),
    hour12: false,
  });
}

export function formatAppDate(value: string | number | Date): string {
  const d = asDate(value);
  if (!d) return '';
  return d.toLocaleDateString(APP_LOCALE, {
    timeZone: APP_TIME_ZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });
}

export function formatAppDateTime(value: string | number | Date): string {
  const d = asDate(value);
  if (!d) return '';
  return d.toLocaleString(APP_LOCALE, {
    timeZone: APP_TIME_ZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  });
}
